import { render, staticRenderFns } from "./SelectAllItemsTableCheckbox.vue?vue&type=template&id=53678e6f"
import script from "./SelectAllItemsTableCheckbox.vue?vue&type=script&lang=js"
export * from "./SelectAllItemsTableCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports